<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title center">{{ data.title | translate | uppercase }}</h1>
<div mat-dialog-content class="center-content content">
  {{ data.message | translate }}
</div>
<div mat-dialog-actions class="center-content">
  @if(!data.hideCancel){
  <button mat-raised-button color="secondary" (click)="close()">
    {{ 'NGX-MESSAGING.cancel' | translate }}
  </button>
  }
  <button mat-raised-button color="primary" (click)="accept()">
    {{ 'NGX-MESSAGING.accept' | translate }}
  </button>
</div>
